import { render, staticRenderFns } from "./FCAssignmentVisualization.vue?vue&type=template&id=28055d2c&scoped=true&"
import script from "./FCAssignmentVisualization.vue?vue&type=script&lang=js&"
export * from "./FCAssignmentVisualization.vue?vue&type=script&lang=js&"
import style0 from "./FCAssignmentVisualization.vue?vue&type=style&index=0&id=28055d2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28055d2c",
  null
  
)

export default component.exports